/* Homepage v3 (demo): shop-the-look hotspots, product tabs, videos that play only on screen. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-h3-look]').forEach(function (box) {
    var go = box.querySelector('[data-h3-look-go]'), name = box.querySelector('[data-h3-look-name]');
    function pick(i) {
      box.querySelectorAll('[data-i]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.i === String(i)); });
      var row = box.querySelector('.h3-look-row[data-i="' + i + '"]');
      if (row && go) { go.href = row.dataset.url; name.textContent = row.dataset.title; }
    }
    box.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) pick(b.dataset.i); });
  });
  document.querySelectorAll('[data-h3-tabs]').forEach(function (sec) {
    var tabs = [].slice.call(sec.querySelectorAll('[role="tab"]'));
    function show(t, focus) {
      tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; document.getElementById(x.getAttribute('aria-controls')).hidden = !on; });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t); });
      t.addEventListener('keydown', function (e) { var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (k) { e.preventDefault(); show(tabs[(i + k + tabs.length) % tabs.length], true); } });
    });
  });
  /* hero banners */
  document.querySelectorAll('[data-h3-hs]').forEach(function (root) {
    var sl = [].slice.call(root.querySelectorAll('.h3-slide')), dots = [].slice.call(root.querySelectorAll('[data-go]')), i = 0;
    if (sl.length < 2) return;
    var T = (+root.dataset.speed || 7) * 1000, t0 = performance.now(), paused = false, auto = root.dataset.autoplay !== 'false' && !reduce;
    function go(n) {
      i = (n + sl.length) % sl.length;
      sl.forEach(function (s, k) {
        var on = k === i; s.classList.toggle('on', on); s.setAttribute('aria-hidden', !on);
        s.querySelectorAll('a,button').forEach(function (x) { x.tabIndex = on ? 0 : -1; });
        if (on) s.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === i); var em = d.querySelector('em'); if (em) em.style.width = k < i ? '100%' : '0%'; });
      t0 = performance.now();
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.go); }); });
    root.addEventListener('focusin', function (e) { try { if (e.target.matches(':focus-visible')) paused = true; } catch (err) {} });
    root.addEventListener('focusout', function () { paused = false; });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    function tick(now) {
      requestAnimationFrame(tick);
      if (!auto) return;
      var em = dots[i] && dots[i].querySelector('em');
      if (paused) { t0 = now - (em ? (parseFloat(em.style.width) || 0) / 100 * T : 0); return; }
      var p = Math.min(1, (now - t0) / T); if (em) em.style.width = (p * 100) + '%';
      if (p >= 1) go(i + 1);
    }
    go(0); requestAnimationFrame(tick);
  });
  var vids = document.querySelectorAll('[data-h3-videos] video');
  if (!vids.length || reduce || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
  }, { threshold: 0.4 });
  vids.forEach(function (v) { v.muted = true; io.observe(v); });
})();

/* v0.27.0 navigation bar under sideways rows ([data-h3-railnav] right after the row):
   a track showing the position (click or drag) plus previous/next buttons; hidden when everything fits. */
(function () {
  document.querySelectorAll('[data-h3-railnav]').forEach(function (nav) {
    var rail = nav.previousElementSibling; if (!rail) return;
    var track = nav.querySelector('[data-rn-track]'), thumb = nav.querySelector('[data-rn-thumb]');
    var btns = [].slice.call(nav.querySelectorAll('[data-rn-step]'));
    var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    function max() { return rail.scrollWidth - rail.clientWidth; }
    function update() {
      var m = max(), fits = m <= 4; nav.hidden = fits; if (fits) return;
      var w = Math.max(12, rail.clientWidth / rail.scrollWidth * 100), x = Math.min(1, Math.max(0, rail.scrollLeft / m));
      thumb.style.width = w + '%'; thumb.style.left = (x * (100 - w)) + '%';
      btns[0].disabled = rail.scrollLeft <= 2; btns[1].disabled = rail.scrollLeft >= m - 2;
    }
    function step(dir) {
      var item = rail.firstElementChild, gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var one = item ? item.getBoundingClientRect().width + gap : rail.clientWidth;
      var by = Math.max(one, Math.floor((rail.clientWidth + gap) / one) * one);
      rail.scrollBy({ left: dir * by, behavior: smooth });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { step(+b.dataset.rnStep); }); });
    /* click or drag on the track */
    var drag = null;
    function toPos(clientX) {
      var r = track.getBoundingClientRect(), tw = thumb.getBoundingClientRect().width;
      var f = (clientX - r.left - (drag ? drag.off : tw / 2)) / Math.max(1, r.width - tw);
      return Math.min(1, Math.max(0, f)) * max();
    }
    track.addEventListener('pointerdown', function (e) {
      var tr = thumb.getBoundingClientRect(), onThumb = e.clientX >= tr.left && e.clientX <= tr.right;
      drag = { off: onThumb ? e.clientX - tr.left : tr.width / 2 };
      track.setPointerCapture(e.pointerId); rail.style.scrollSnapType = 'none';
      rail.scrollTo({ left: toPos(e.clientX), behavior: onThumb ? 'auto' : smooth });
      e.preventDefault();
    });
    track.addEventListener('pointermove', function (e) { if (drag) rail.scrollLeft = toPos(e.clientX); });
    function end() { if (!drag) return; drag = null; rail.style.scrollSnapType = ''; }
    track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end);
    rail.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
    update();
  });
})();
